export default __webpack_public_path__ + "static/media/bg-pattern-bottom-desktop.32aa6571.svg";